import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const SamsaraRegistration = lazyLoader(
  () =>
    import(
      "Containers/SamsaraIntegration/SamsaraRegistration/SamsaraRegistration"
    )
);

export const SamsaraRegistrationPage = () => {
  return (
    <Layout>
      <SamsaraRegistration />
    </Layout>
  );
};
